import type { Script } from '@features/scripts/types';

const normalize = (value: string | null | undefined): string =>
  (value ?? '').trim().toLowerCase();

export const matchScriptByProcedureName = (
  procedureName: string | null | undefined,
  scripts: Script[]
): Script | null => {
  const target = normalize(procedureName);
  if (!target) return null;
  return scripts.find(script => normalize(script.globalId) === target) ?? null;
};
